export const GET_PRODUCT = "GET_PRODUCT";
export const GET_SINGLEPRODUCT = "GET_SINGLEPRODUCT";
export const GET_USER = "GET_USER";
export const POST_USER = "POST_USER";
export const EDIT_USER = "EDIT_USER";
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const USER_LOGIN_SUCCESS="USER_LOGIN_SUCCESS"
export const RESET_USER="RESET_USER"
export const GET_ADDRESS="GET_ADDRESS"
export const ADD_ADDRESS="ADD_ADDRESS"
export const EDIT_ADDRESS="EDIT_ADDRESS"
export const DELETE_ADDRESS="DELETE_ADDRESS"
export const ADD_TO_CART="ADD_TO_CART"
export const GET_CART="GET_CART"
export const GET_CART_LENGTH="GET_CART_LENGTH"
export const GET_CART_ID="GET_CART_ID"
export const ORDER_COFM_STATUS="ORDER_COFM_STATUS"
export const GET_ORDER_DATA="GET_ORDER_DATA"
export const PAGES="PAGES"
export const TOTAL_PRICE="TOTAL_PRICE"
